const B_1 = [
    {
        title: '投标人澄清问题管理',
        path: '/bidding/projectflow/fabiao/yygl/list'
    }
]
export default {
    path: 'yygl',
    component: () => import(/*webpackChunkName: 'bidding-kai-getoffer'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/fa/yygl/list'),
            meta: {
                title: '投标人澄清问题管理',
                bread: B_1
            },
        },
        {
            path:"edit",
            component: () => import('@views/bidding/views/project-flow/fa/yygl/edit'),
            meta: {
                title: '回复问题管理',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/fa/yygl/detail'),
            meta: {
                title: '详细信息',
                bread: B_1
            },
        },
    ]
}